import { useContext } from 'react';
import { AuthDialogContext, type AuthDialogValue } from './auth-dialog-context';

/**
 * Opens and closes the sign-in dialog.
 *
 * Throws outside the provider rather than returning a no-op: a button that
 * silently does nothing is a bug that reaches production, and one that throws in
 * development never does.
 */
export function useAuthDialog(): AuthDialogValue {
  const value = useContext(AuthDialogContext);

  if (!value) {
    throw new Error('useAuthDialog must be used inside <AuthDialogProvider>.');
  }

  return value;
}
